
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { BaseCouponItem, CouponInfoListItem } from '@xt/client/types/coupon'
import SlidePop from '../coupon/SlidePop.vue'
import GiftCoupon from './GiftCoupon.vue'
import LaunchWeapp from '@xt/mobile/components/launchWeapp/index.vue'
import WeOpenTag from '@xt/mobile/configs/wx-open-tag'

@Observer
@Component({
  components: {
    SlidePop,
    GiftCoupon,
    LaunchWeapp
  }
})
export default class OrderCouponGift extends Vue {
  @Prop({ default: false }) show: boolean
  @Prop({ required: true }) data: { failList: Array<BaseCouponItem>; successList: Array<BaseCouponItem> }
  slide = 0

  secondViewInfo: {
    list: CouponInfoListItem[]
    coupon: BaseCouponItem | null
  } = {
    list: [],
    coupon: null
  }

  get isEmbeddedH5Page() {
    return this.$store.$global.isEmbeddedH5Page
  }

  get username() {
    return this.$store.$global.production ? WeOpenTag.applictions.uc : WeOpenTag.applictions.uc_trial
  }

  get path() {
    return `/pages/coupon/packs/index`
  }

  get envVersion() {
    return this.$store.$global.production ? 'release' : 'trial'
  }

  async readMessage() {
    await this.$store.$coupon.readOrderSuccessCouponGift(this.data.successList.map(data => data.couponCode))
  }

  async handleClose() {
    await this.readMessage()

    this.$emit('close')
  }

  handleClickUseInfo({ list, coupon }: { list: Array<CouponInfoListItem>; coupon: BaseCouponItem }) {
    this.secondViewInfo = {
      list,
      coupon
    }
    this.slide = 1
  }

  handleConfirm() {
    if (!this.$store.$global.isEmbeddedH5Page) return

    wx.miniProgram.navigateTo({
      url: '/pages/coupon/packs/index',
      success: () => {
        this.handleClose()
      }
    })
  }

  mounted() {}
}
